<template>
  <div ref="cell" class="grid-view__cell grid-field-single-select__cell">
    <div class="grid-field-single-select">
      <div
        v-if="value"
        class="grid-field-single-select__option"
        :class="'background-color--' + value.color"
      >
        <SearchHighlightedText :text="value.value" :search-term="searchTerm" />
      </div>
    </div>
  </div>
</template>

<script>
import SearchHighlightedText from '@baserow/modules/database/components/view/grid/fields/SearchHighlightedText'

export default {
  name: 'FunctionalGridViewFieldSingleSelect',
  components: { SearchHighlightedText },
  props: {
    value: {
      type: Object,
      default: null,
    },
    searchTerm: {
      type: String,
      required: false,
      default: '',
    },
  },
}
</script>
